import { observer } from "owa-mobx-react";
import React from "react";
import { continueGetDataFromParentWindow } from "../utils/getDataFromParentWindow";
import { getStore } from "../store/childStore";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { PopoutChildState } from "../store/schema/PopoutChildStore";
/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid importing Spinner from '@fluentui/react', as this package has started migration to Fluent UI 9. Import Spinner from '@fluentui/react-components' instead. */
import { Spinner } from "@fluentui/react/lib/Spinner";

export interface PopoutLoadingViewProps {
    loadingString: string;
}

import { view } from "./PopoutLoadingView.scss";

const defaultExport: React.FunctionComponent<PopoutLoadingViewProps> = observer(function PopoutLoadingView(props: PopoutLoadingViewProps) {
    React.useEffect(() => {
        if (!isGlobalFeatureEnabled("rp-popoutsDebug")) {
            loadData();
        }
    }, []);
    const renderSpinner = () => {
        return (<span>
                    <Spinner />
                    {props.loadingString}
                </span>);
    };
    return (<div className={view}>
                {getStore().state == PopoutChildState.Loading
            ? renderSpinner()
            : renderDebugButton()}
            </div>);
}, "PopoutLoadingView");
export default defaultExport;

function loadData() {
    continueGetDataFromParentWindow();
}

function renderDebugButton() {
    // This UI is only visible when rp-popoutsDebug flight is enabled, and is used for debugging only,
    // so no need to be localized
    /* eslint-disable-next-line react/button-has-type -- (https://aka.ms/OWALintWiki)
     * Baseline, DO NOT COPY-PASTE!, change this line with a justification or add proper type prop to the button between "button", "submit", or "reset" https://github.com/jsx-eslint/eslint-plugin-react/blob/master/docs/rules/button-has-type.md
     *	> Missing an explicit type attribute for button */
    return <button onClick={loadData}>Get Data</button>;
}
